import { Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[resizeListener]'
})
export class ResizeListenerDirective implements OnInit {

  @Input() resizeListener: { width: number, class: string } = null;
  @HostListener('window:resize', ['$event'])
  onResize() {
    if (this.resizeListener) {
      const width = parseInt(this.el.nativeElement.offsetWidth, 10);
      // console.log('WIDTH', this.resizeListener.class, width);
      if (width < this.resizeListener.width) {
        this.rendered.addClass(this.el.nativeElement, this.resizeListener.class);
      } else {
        this.rendered.removeClass(this.el.nativeElement, this.resizeListener.class);
      }
    }
  }

  constructor(private el: ElementRef, private rendered: Renderer2) {}

  ngOnInit(): void {
    this.onResize();
  }

}